import React from "react";


interface ExportDataProps {
    data: any[],
    filename: string
}
const ExportDataComponent: React.FC<ExportDataProps> = ({ data, filename }) => {

    //skill/group/path names may contain ',' 
    const escapeCsvField = (value: any) => {
        const str = value === null || value === undefined ? "" : String(value);
        return `"${str.replace(/"/g, '""')}"`;
    }

    const convertToCsv = (objArray: any) => {
        const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        if (array.length === 0) return "";

        const headers = Object.keys(array[0]);
        let str = headers.map(escapeCsvField).join(",") + "\r\n";

        for (let i = 0; i < array.length; i++){
            let line = "";
            for(let idx in array[i]){
                if(line !== "") line += ",";
                line += escapeCsvField(array[i][idx]);
            }
            str += line + "\r\n";
        }
        return str;
    }

    const downloadCsv = () => {
        const csvData = new Blob([convertToCsv(data)], { type: 'text/csv'});
        const csvUrl = URL.createObjectURL(csvData);
        const link = document.createElement('a');
        link.href = csvUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return (
        <button className="btn-outlined-primary m-b--50" onClick={downloadCsv} title="Export data to csv"> Export</button>
    );

}

export default ExportDataComponent